export function TagViewModel(data) {
  this.Id = data.ID;
  this.Name = data.Name;
}
